import React from "react";
import Sidebar from "./Sidebar";
import HeaderBar from "./HeaderBar";

export default function Layout({ children, onSearch }) {
  return (
    <div className="min-h-screen bg-taupe-light">
      <HeaderBar onSearch={onSearch} />
      <div className="flex pt-16">
        <Sidebar />
        <main className="flex-1 ml-60 pl-0">
          {children}
        </main>
      </div>
    </div>
  );
}